import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import Box from '@enlighten/design-system/dist/Box';
import Button from '@enlighten/design-system/dist/Button';
import Stack from '@enlighten/design-system/dist/Stack';
import Typography from '@enlighten/design-system/dist/Typography';
import Image from 'next/image';
import BgImg from '../../assets/images/hanwha/section-1-bg.png';
import TitleImgPc from '../../assets/images/hanwha/section-1-title.png';
import TitleImgMobile from '../../assets/images/hanwha/section-1-title-m.png';
const PHONE_NUMBER = '1644-9664';
const alt = `재산손해 + 휴업손해 + 배상책임
한화손해 x TPA코리아 태양광발전소종합보험

한 번에, 한화로
태양광발전소를 위한 맞춤형 보험으로 든든하게 완벽 관리
* 대표계약자: 올비즈커넥트(주) | 모집주체: TPA KOREA(주)`;
export default function Section1({ onClickPhone, onClickOnline, }) {
    return (_jsxs(Stack, { justifyContent: "center", alignItems: "center", gap: { xs: 5, md: '60px' }, padding: { xs: '60px 24px 100px', md: '210px 24px 196px' }, sx: {
            background: `url(${process.env.NEXT_PUBLIC_IS_NEXT_JS === 'true' ||
                process.env.NEXT_PRIVATE_IS_NEXT_JS === 'true'
                ? BgImg.src
                : BgImg}) no-repeat center / cover`,
        }, children: [_jsx(Box, { display: { xs: 'none', md: 'block' }, maxWidth: 1187, sx: {
                    '& img': {
                        width: '100%',
                        height: 'auto',
                    },
                }, children: process.env.NEXT_PUBLIC_IS_NEXT_JS === 'true' ||
                    process.env.NEXT_PRIVATE_IS_NEXT_JS === 'true' ? (_jsx(Image, { src: TitleImgPc, alt: alt, width: 1187 })) : (_jsx("img", { src: TitleImgPc, alt: alt, width: 1187 })) }), _jsx(Box, { display: { xs: 'block', md: 'none' }, sx: {
                    '& img': {
                        width: '100%',
                        height: 'auto',
                    },
                }, children: process.env.NEXT_PUBLIC_IS_NEXT_JS === 'true' ||
                    process.env.NEXT_PRIVATE_IS_NEXT_JS === 'true' ? (_jsx(Image, { src: TitleImgMobile, alt: alt })) : (_jsx("img", { src: TitleImgMobile, alt: alt })) }), _jsxs(Stack, { direction: { md: 'row' }, justifyContent: "center", alignItems: "center", flexWrap: "wrap", gap: { xs: 2, md: '12px' }, width: { xs: '100%', md: 'auto' }, children: [_jsxs(Button, { variant: "contained", onClick: onClickPhone, sx: {
                            display: { xs: 'none', md: 'block' },
                            bgcolor: '#F37321',
                            textAlign: 'center',
                            lineHeight: 1.5,
                            width: { xs: '100%', md: 'auto' },
                            height: 'auto',
                            minHeight: 0,
                            border: '1px solid #F37321',
                            padding: '16px 32px',
                            ':hover': {
                                bgcolor: '#FF9E62',
                                borderColor: '#FF9E62',
                            },
                        }, children: ["\uC804\uD654\uC0C1\uB2F4 (TPA\uCF54\uB9AC\uC544) ", PHONE_NUMBER] }), _jsx(Button, { variant: "contained", onClick: onClickPhone, sx: {
                            display: { xs: 'block', md: 'none' },
                            bgcolor: '#F37321',
                            textAlign: 'center',
                            lineHeight: 1.5,
                            width: { xs: '100%', md: 'auto' },
                            height: 'auto',
                            minHeight: 0,
                            border: '1px solid #F37321',
                            padding: '13px 24px',
                            ':hover': {
                                bgcolor: '#FF9E62',
                                borderColor: '#FF9E62',
                            },
                        }, children: "\uC804\uD654 \uC0C1\uB2F4\uD558\uAE30 (TPA\uCF54\uB9AC\uC544)" }), _jsx(Button, { variant: "outlined", onClick: onClickOnline, sx: {
                            bgcolor: 'common.white',
                            lineHeight: 1.5,
                            width: { xs: '100%', md: 'auto' },
                            height: 'auto',
                            minHeight: 0,
                            padding: { xs: '13px 24px', md: '16px 32px' },
                        }, children: "\uC628\uB77C\uC778 \uACAC\uC801\uBB38\uC758" }), _jsx(Typography, { display: { xs: 'block', md: 'none' }, fontSize: 12, fontWeight: 400, textAlign: "center", lineHeight: 1.5, color: "#D5C8C1", children: "* \uB300\uD45C\uACC4\uC57D\uC790: \uC62C\uBE44\uC988\uCEE4\uB125\uD2B8(\uC8FC) \uFF5C \uBAA8\uC9D1\uC8FC\uCCB4: TPA KOREA(\uC8FC)" })] })] }));
}
